import { render, staticRenderFns } from "./focus_merchandise.vue?vue&type=template&id=5c8df50e&scoped=true"
import script from "./focus_merchandise.vue?vue&type=script&lang=js"
export * from "./focus_merchandise.vue?vue&type=script&lang=js"
import style0 from "./focus_merchandise.vue?vue&type=style&index=0&id=5c8df50e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8df50e",
  null
  
)

export default component.exports